export enum ResultMapType {
  NORMAL = "NORMAL",
  DIFFERENCE = "DIFFERENCE",
  RELATIVE_DIFFERENCE = "RELATIVE_DIFFERENCE",
}

export enum CalculationType {
  IFDM = "IFDM",
  OSPM = "OSPM",
  IFDM_FALLBACK = "IFDM_FALLBACK",
}

export type Results = CalculationResult[];

export interface CalculationResult {
  scenarioId: number;
  scenarioName: string;
  baseline: boolean;
  substanceId: number;
  substanceName: string;
  mapType: "string";
  mapTypeKey: ResultMapType;
  geoserverLayer: string;
  defaultLegend: string;
  minMaxLegend: string;
  dynamicLegend: string;
  calculationType: CalculationType;
  ifdmType: string;
}

export enum PoiTimeseriesType {
  HOURLY = "HOURLY",
  DAILY = "DAILY",
}
export interface PoiTimeseries {
  scenarioId: number;
  substanceId: number;
  poiId: number;
  type: PoiTimeseriesType;
  unit: string;
  timeseriesList: Array<{
    date: string;
    value: number;
  }>;
}
export interface Selection {
  scenario: number | string | null;
  substance: number | string | null;
  calculation: number | string | null;
}
